// Safe clipboard helper. In browser iframes, the async Clipboard API is
// commonly blocked by Permissions-Policy and the resulting rejection triggers
// CRA's dev-error overlay even when wrapped in try/await. To avoid that we
// detect the iframe case and jump straight to the textarea + execCommand fallback.
// Never throws; always resolves to boolean.

function _isIframe() {
  try {
    return window.self !== window.top;
  } catch (_) {
    return true; // cross-origin frame: treat as iframe
  }
}

function _legacyCopy(value) {
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.left = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return !!ok;
  } catch (_) {
    return false;
  }
}

export async function copyToClipboard(text) {
  const value = text == null ? "" : String(text);
  // In iframes (preview environment) the async Clipboard API is blocked by
  // Permissions-Policy — use the legacy path directly to avoid unhandled
  // promise rejections surfacing in CRA's error overlay.
  if (_isIframe()) {
    return _legacyCopy(value);
  }
  // Top-level document: prefer the async Clipboard API.
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
      // Chain .catch() so a rejection never bubbles up as "uncaught"
      const ok = await navigator.clipboard.writeText(value).then(
        () => true,
        () => false,
      );
      if (ok) return true;
    }
  } catch (_) {
    // fall through
  }
  return _legacyCopy(value);
}
